






















































import Vue from "vue";
import AbpBase from "@/lib/abpbase";
import { Component, Watch, Prop } from "vue-property-decorator";
import { GetCommunityAll } from "@/api/pdCommunity";
import { PushPatient } from "@/api/pdReferral";
import { HubConnectionBuilder } from "@aspnet/signalr";
import { GetTeamList, GetAllUserList } from "@/api/pdTeam";

/**
 * 批量推送
 */
@Component({})
export default class PdPushPatientBatch extends AbpBase {
  model: any = {
    sourceCommunityId: null,
    sourceCommunityName: null,
    targetCommunityId: null,
    sourceTeamId: null,
    targetTeamId: null,
    sourceDoctor: null,
    targetDoctor: null,
    referralUserName: "",
    referralTime: "",
    remarks: ""
  };
  communityList: any = [];
  allTeamList: any = [];
  teamList: any = [];
  allUserList: any = [];
  doctorList: any = [];

  rules = {
    targetCommunityId: [
      {
        type: "number",
        required: true,
        message: "请选择推目标社区",
        trigger: "change"
      }
    ]
  };

  created() {
    this.initDic();
    this.model.referralTime = this.formatDate(new Date());
    let user = this.$store.state.session.user;
    if (user) {
      this.model.referralUserName = user.name;
      this.model.sourceCommunityId = user.communityId;
      this.model.sourceCommunityName = user.communityName;
    }
  }

  async initDic() {
    let res = await GetCommunityAll();
    this.communityList = res.objects;
    // let user = this.$store.state.session.user;
    // if (user.communityName == "兴安盟人民医院") {
    //   this.communityList = this.communityList.filter(x => x.name != "兴安盟人民医院");
    // } else {
    //   this.communityList = this.communityList.filter(x => x.name == "兴安盟人民医院");
    //   this.model.targetCommunityId = this.communityList[0].id;
    // }

    let resTeam = await GetTeamList();
    this.allTeamList = resTeam.data;

    let resUser = await GetAllUserList();
    this.allUserList = resUser.data;
  }

  handleCommunityChanged() {
    if (this.model.targetCommunityId) {
      this.teamList = this.allTeamList.filter(
        x => x.communityId == this.model.targetCommunityId
      );
    }
  }

  handleTeamChanged() {
    if (this.model.targetTeamId) {
      this.doctorList = this.allUserList.filter(
        x => x.teamId == this.model.targetTeamId
      );
    }
  }

  async submit() {
    this.$refs["form"].validate(async valid => {
      if (!valid) {
        return null;
      }
    });
    return this.model;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdReferral/pdScreening/pushBatch.vue